module.exports = __webpack_public_path__ + "img/commentSection.79a1ac93.png";